/**
 * Cutting Board Landing Page
 * Board selection + pre-made designs + custom designer
 * 3Blades Maker Lab
 */
(function () {
  'use strict';

  var config = JSON.parse(document.getElementById('board-landing-data').textContent);
  var boardProducts = [];
  var selectedBoardIndex = 0;
  var designType = 'pick';
  var selectedDesignName = null;
  var activeCategoryIndex = 0;
  var uploadedFileData = null;
  var uploadedFileName = null;

  var els = {
    boardGrid: document.getElementById('boardGrid'),
    priceDisplay: document.getElementById('boardPrice'),
    designerBtn: document.getElementById('boardDesignerBtn'),
    boardDescription: document.getElementById('boardDescription'),
    pickSection: document.getElementById('boardPickSection'),
    customSection: document.getElementById('boardCustomSection'),
    preMadeAction: document.getElementById('boardPreMadeAction'),
    addToCart: document.getElementById('boardAddToCart'),
    cartHint: document.getElementById('boardCartHint'),
    designCats: document.getElementById('boardDesignCats'),
    designGrid: document.getElementById('boardDesignGrid')
  };

  function fetchProducts() {
    var promises = config.boards.map(function (board) {
      return fetch('/products/' + board.handle + '.json')
        .then(function (r) { return r.json(); })
        .then(function (data) { return data.product; })
        .catch(function () { return null; });
    });

    Promise.all(promises).then(function (products) {
      boardProducts = products;
      buildBoardGrid();
      buildDesignCategories();
      updateDisplay();
    });
  }

  // Board cards
  function buildBoardGrid() {
    els.boardGrid.innerHTML = '';
    for (var i = 0; i < config.boards.length; i++) {
      var board = config.boards[i];
      var product = boardProducts[i];

      var card = document.createElement('div');
      card.className = 'landing__board-card' + (i === 0 ? ' landing__board-card--active' : '');
      card.setAttribute('data-board', i);

      if (product && product.images && product.images.length > 0) {
        var img = document.createElement('img');
        img.className = 'landing__board-img';
        img.src = product.images[0].src.replace(/\.([a-z]+)\?/, '_400x300.$1?');
        img.alt = board.name + ' cutting board';
        img.loading = 'lazy';
        card.appendChild(img);
      } else {
        var placeholder = document.createElement('div');
        placeholder.className = 'landing__design-placeholder';
        placeholder.style.aspectRatio = '4/3';
        placeholder.textContent = board.shortName;
        card.appendChild(placeholder);
      }

      var info = document.createElement('div');
      info.className = 'landing__board-info';
      var name = document.createElement('div');
      name.className = 'landing__board-name';
      name.textContent = board.shortName;
      info.appendChild(name);
      var price = document.createElement('div');
      price.className = 'landing__board-price';
      price.textContent = board.engravedPrice;
      info.appendChild(price);
      if (board.woodLine) {
        var desc = document.createElement('div');
        desc.className = 'landing__board-wood';
        desc.textContent = board.woodLine;
        info.appendChild(desc);
      }

      card.appendChild(info);
      card.addEventListener('click', handleBoardClick);
      els.boardGrid.appendChild(card);
    }
  }

  function handleBoardClick(e) {
    var card = e.currentTarget;
    selectedBoardIndex = parseInt(card.getAttribute('data-board'), 10);
    var cards = els.boardGrid.querySelectorAll('.landing__board-card');
    for (var i = 0; i < cards.length; i++) cards[i].classList.remove('landing__board-card--active');
    card.classList.add('landing__board-card--active');
    updateDisplay();
  }

  // Design type toggle
  function setupDesignTypeToggle() {
    var container = document.getElementById('boardDesignType');
    var buttons = container.querySelectorAll('.landing__option-btn');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', function () {
        var siblings = this.parentElement.querySelectorAll('.landing__option-btn');
        for (var j = 0; j < siblings.length; j++) siblings[j].classList.remove('landing__option-btn--active');
        this.classList.add('landing__option-btn--active');
        designType = this.getAttribute('data-value');

        if (designType === 'custom') {
          els.pickSection.classList.add('landing__hidden');
          els.customSection.classList.remove('landing__hidden');
          els.preMadeAction.classList.add('landing__hidden');
        } else {
          els.pickSection.classList.remove('landing__hidden');
          els.customSection.classList.add('landing__hidden');
          els.preMadeAction.classList.remove('landing__hidden');
          // Clear upload state
          uploadedFileData = null;
          uploadedFileName = null;
          var statusEl = document.getElementById('boardUploadStatus');
          var uploadCartBtn = document.getElementById('boardUploadAddToCart');
          if (statusEl) statusEl.classList.add('landing__hidden');
          if (uploadCartBtn) uploadCartBtn.classList.add('landing__hidden');
        }
        updateDesignerLink();
      });
    }
  }

  // Design categories + grid
  function buildDesignCategories() {
    els.designCats.innerHTML = '';
    for (var i = 0; i < config.designs.length; i++) {
      var cat = config.designs[i];
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'landing__cat-btn' + (i === 0 ? ' landing__cat-btn--active' : '');
      btn.textContent = cat.category;
      btn.setAttribute('data-cat', i);
      btn.addEventListener('click', handleCategoryClick);
      els.designCats.appendChild(btn);
    }
    renderDesignGrid(0);
  }

  function handleCategoryClick(e) {
    var btn = e.currentTarget;
    var cats = els.designCats.querySelectorAll('.landing__cat-btn');
    for (var i = 0; i < cats.length; i++) cats[i].classList.remove('landing__cat-btn--active');
    btn.classList.add('landing__cat-btn--active');
    activeCategoryIndex = parseInt(btn.getAttribute('data-cat'), 10);
    selectedDesignName = null;
    updateAddToCartState();
    renderDesignGrid(activeCategoryIndex);
  }

  function renderDesignGrid(catIndex) {
    els.designGrid.innerHTML = '';
    var items = config.designs[catIndex].items;

    for (var i = 0; i < items.length; i++) {
      var design = items[i];
      var card = document.createElement('div');
      card.className = 'landing__design-card';

      // Check for matching product image by slug
      var imgSrc = null;
      for (var p = 0; p < boardProducts.length; p++) {
        if (!boardProducts[p]) continue;
        var images = boardProducts[p].images || [];
        for (var j = 0; j < images.length; j++) {
          var alt = (images[j].alt || '').toLowerCase();
          if (alt.indexOf(design.slug) > -1) {
            imgSrc = images[j].src;
            break;
          }
        }
        if (imgSrc) break;
      }

      if (imgSrc && design.hasImage) {
        var img = document.createElement('img');
        img.className = 'landing__design-img';
        img.src = imgSrc.replace(/\.([a-z]+)\?/, '_200x200.$1?');
        img.alt = design.name;
        img.loading = 'lazy';
        card.appendChild(img);
      } else {
        card.classList.add('landing__design-card--coming-soon');
        var placeholder = document.createElement('div');
        placeholder.className = 'landing__design-placeholder';
        placeholder.textContent = 'Coming Soon';
        card.appendChild(placeholder);
      }

      var nameEl = document.createElement('div');
      nameEl.className = 'landing__design-name';
      nameEl.textContent = design.name;
      card.appendChild(nameEl);

      var descEl = document.createElement('div');
      descEl.className = 'landing__design-desc';
      descEl.textContent = design.desc;
      card.appendChild(descEl);

      if (design.hasImage) {
        card.setAttribute('data-design', design.name);
        card.addEventListener('click', handleDesignClick);
      }

      els.designGrid.appendChild(card);
    }
  }

  function handleDesignClick(e) {
    var card = e.currentTarget;
    var cards = els.designGrid.querySelectorAll('.landing__design-card');
    for (var i = 0; i < cards.length; i++) cards[i].classList.remove('landing__design-card--active');
    card.classList.add('landing__design-card--active');
    selectedDesignName = card.getAttribute('data-design');
    updateAddToCartState();
  }

  function updateAddToCartState() {
    if (selectedDesignName) {
      els.addToCart.disabled = false;
      els.addToCart.textContent = 'Add to Cart â€” ' + selectedDesignName;
      els.cartHint.textContent = '';
    } else {
      els.addToCart.disabled = true;
      els.addToCart.textContent = 'Select a Design Above';
      els.cartHint.textContent = 'Pick a board and design, then add to cart.';
    }
  }

  // Add pre-made design to cart
  function setupAddToCart() {
    els.addToCart.addEventListener('click', function () {
      if (!selectedDesignName) return;
      var product = boardProducts[selectedBoardIndex];
      if (!product) return;

      // Find the "Custom Engraved" variant
      var variant = null;
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].title.toLowerCase().indexOf('custom') > -1) {
          variant = product.variants[i];
          break;
        }
      }
      if (!variant) variant = product.variants[0];

      els.addToCart.disabled = true;
      els.addToCart.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: variant.id,
            quantity: 1,
            properties: {
              'Design': selectedDesignName,
              'Design Source': 'Pre-made',
              'Board Style': config.boards[selectedBoardIndex].name
            }
          }]
        })
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () {
          els.addToCart.disabled = false;
          els.addToCart.textContent = 'Add to Cart â€” ' + selectedDesignName;
          alert('Something went wrong. Please try again.');
        });
    });
  }

  function updateDisplay() {
    var board = config.boards[selectedBoardIndex];
    els.priceDisplay.textContent = board.engravedPrice + '.00';
    updateDesignerLink();
    els.boardDescription.innerHTML =
      '<h3>' + board.name + '</h3>' +
      '<p>' + board.description + ' <strong>' + board.dimensions + '</strong></p>';
  }

  function updateDesignerLink() {
    var board = config.boards[selectedBoardIndex];
    els.designerBtn.href = '/products/' + board.handle + '?board=' + selectedBoardIndex;
  }

  // File upload handling
  function setupFileUpload() {
    var fileInput = document.getElementById('boardFileUpload');
    var statusEl = document.getElementById('boardUploadStatus');
    var uploadCartBtn = document.getElementById('boardUploadAddToCart');
    if (!fileInput) return;

    fileInput.addEventListener('change', function (e) {
      var file = e.target.files[0];
      if (!file) return;

      uploadedFileName = file.name;
      var reader = new FileReader();
      reader.onload = function (ev) {
        uploadedFileData = ev.target.result;
        statusEl.textContent = 'Uploaded: ' + uploadedFileName;
        statusEl.classList.remove('landing__hidden');
        uploadCartBtn.classList.remove('landing__hidden');
        uploadCartBtn.disabled = false;
        uploadCartBtn.textContent = 'Add Uploaded Design to Cart';
      };
      reader.readAsDataURL(file);
    });

    uploadCartBtn.addEventListener('click', function () {
      if (!uploadedFileData) return;
      var product = boardProducts[selectedBoardIndex];
      if (!product) return;

      var variant = null;
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].title.toLowerCase().indexOf('custom') > -1) {
          variant = product.variants[i];
          break;
        }
      }
      if (!variant) variant = product.variants[0];

      uploadCartBtn.disabled = true;
      uploadCartBtn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: variant.id,
            quantity: 1,
            properties: {
              'Design': 'Upload: ' + uploadedFileName,
              'Design Source': 'Customer Upload',
              'Board Style': config.boards[selectedBoardIndex].name,
              '_Uploaded Design': uploadedFileData
            }
          }]
        })
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () {
          uploadCartBtn.disabled = false;
          uploadCartBtn.textContent = 'Add Uploaded Design to Cart';
          alert('Something went wrong. Please try again.');
        });
    });
  }

  function init() {
    fetchProducts();
    setupDesignTypeToggle();
    setupAddToCart();
    setupFileUpload();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
